package com.siriusxm.pia.views.unifiedaggregator

/**
 * Converts an AWS ARN to a link to the corresponding resource in the AWS Console.
 * Supports EventBridge event buses, Kinesis streams, Lambda functions, SQS queues,
 * and CloudWatch log groups. Returns null if the ARN format is not recognized.
 */
fun arnToConsoleUrl(arn: String): String? {
    val parts = arn.split(":")
    if (parts.size < 6) return null

    val region = parts[3]
    val service = parts[2]
    val baseUrl = "https://$region.console.aws.amazon.com"

    return when (service) {
        "events" -> {
            val busName = arn.substringAfterLast("/")
            "$baseUrl/events/home?region=$region#/eventbus/$busName"
        }
        "kinesis" -> {
            val streamName = arn.substringAfterLast("/")
            "$baseUrl/kinesis/home?region=$region#/streams/details/$streamName/monitoring"
        }
        "lambda" -> {
            val functionName = arn.substringAfterLast("function:")
            "$baseUrl/lambda/home?region=$region#/functions/$functionName"
        }
        "sqs" -> {
            val accountId = parts[4]
            val queueName = parts[5]
            "$baseUrl/sqs/v3/home?region=$region#/queues/https%3A%2F%2Fsqs.$region.amazonaws.com%2F$accountId%2F$queueName"
        }
        "logs" -> {
            val logGroup = arn.substringAfter("log-group:").substringBefore(":")
            "$baseUrl/cloudwatch/home?region=$region#logsV2:log-groups/log-group/${logGroup.replace("/", "%252F")}"
        }
        else -> null
    }
}
